import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { signInService } from '@/lib/auth/ory/service';
import type { SsoErrorDetail } from '@/lib/auth/ory/service/types';

const SearchSchema = z.object({
  id: z.string(),
});

export const Route = createFileRoute('/auth/sign-in/error/')({
  validateSearch: zodValidator(SearchSchema),
  loaderDeps: ({ search }) => ({ id: search.id }),
  loader: async ({ deps }) => {
    try {
      const flowError = await signInService.getFlowError(deps.id);
      const errorDetail = flowError.error as SsoErrorDetail | undefined;
      return { ssoError: errorDetail ?? null };
    } catch (error) {
      console.warn('Failed to load SSO error, redirecting to sign-in:', error);
      throw redirect({ to: '/auth/sign-in' });
    }
  },
});
